import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { useLang } from '../../i18n';
import { Reveal } from '../Reveal';
import { Img } from '../Img';

/** Blocco focus sulle Shades in home: il concept in due righe + una foto unica
 *  ambientata, poi l'utente clicca ed entra nella pagina Shades (concept + gioco).
 *  Lo slot foto (ASSETS A-02) resta un blocco neutro con la striscia dei cinque
 *  colori veri finché il file non c'è. */
export const ShadesFocus = ({ shades }) => {
  const { t } = useLang();
  if (!shades?.length) return null;

  return (
    <section data-testid="home-shades" className="py-20 md:py-32">
      <div className="wrap grid items-center gap-12 lg:grid-cols-2 lg:gap-20">
        <Reveal>
          <h2 className="max-w-[16ch] text-[30px] leading-[1.06] md:text-[40px] lg:text-[52px]">{t('shades.title')}</h2>
          <p className="prosa mt-7 max-w-[46ch]">{t('shades.lead')}</p>
          <Link to="/storie/shades" data-testid="home-shades-cta" className="btn btn-ink mt-9">
            {t('home.shadesCta')}
            <ArrowUpRight size={15} strokeWidth={2} />
          </Link>
        </Reveal>

        <Reveal delay={0.08}>
          <div className="relative aspect-[4/3] overflow-hidden bg-carta-2">
            <Img
              src="/assets/shades/ambient.webp"
              alt={t('shades.photoAlt')}
              onError={(e) => {
                e.currentTarget.style.display = 'none';
              }}
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-x-0 bottom-0 flex h-14" aria-hidden>
              {shades.map((s) => (
                <span key={s.slug} className="flex-1" style={{ backgroundColor: s.hex }} />
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
